export default __webpack_public_path__ + "static/media/Tutorial-Step-3.2.c0b911fc.jpg";